module.exports = __webpack_public_path__ + "static/media/reportsicon.87c92669.svg";